import React from 'react';
import { Switch, Route } from 'react-router-dom';

import AMLandingPage from './pages/amdtx/landing-page/landingpage';
import AMSignupPage from './pages/amdtx/signup-page/signup-page';
import AMSigninPage from './pages/amdtx/signin-page/signin-page';
import AMCartPage from './pages/amdtx/cart-page/cart-page';
import AMCheckoutPage from './pages/amdtx/checkout-page/checkout-page';
import AMSuccessPage from './pages/amdtx/success-page/success-page';

import GoogleCloseBrowser from './pages/google-close-browser/GoogleCloseBrowser';

function App() {
  return (
    <Switch>
      {/* AmDTx */}
      <Route exact path="/">
        <AMLandingPage />
      </Route>
      <Route exact path="/AmBJS">
        <AMLandingPage />
      </Route>
      <Route exact path="/signup">
        <AMSignupPage />
      </Route>
      <Route exact path="/signin">
        <AMSigninPage />
      </Route>
      <Route exact path="/cart">
        <AMCartPage />
      </Route>
      <Route exact path="/checkout">
        <AMCheckoutPage />
      </Route>
      <Route exact path="/success">
        <AMSuccessPage />
      </Route>

      <Route exact path="/google/close">
        <GoogleCloseBrowser />
      </Route>
    </Switch>
  );
}

export default App;
